import { render, staticRenderFns } from "./InkasJouOperationCard.vue?vue&type=template&id=1506bfd1&scoped=true&"
import script from "./InkasJouOperationCard.vue?vue&type=script&lang=js&"
export * from "./InkasJouOperationCard.vue?vue&type=script&lang=js&"
import style0 from "./InkasJouOperationCard.vue?vue&type=style&index=0&id=1506bfd1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1506bfd1",
  null
  
)

export default component.exports